import React from 'react';

import { flagStyles } from '../settings';

const SvgEH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1536px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgEH;
